<template>
  <div>
    <div class="mb-4">
      <div ref="header-title" class="h5 font-weight-bold">
        {{ headerTitle }}
      </div>
      <div v-if="mode === 'additional-criteria'" ref="header-description" class="text-black-50">
        Assessment rubric can define between 3-5 criteria
      </div>
    </div>

    <!-- Pass criteria or First Level-->
    <div class="mt-4">
      <label v-if="mode === 'criteria'" ref="text__pass-criteria" for="input__pass-criteria">{{
        criterion && criterion.pass_title ? criterion.pass_title : 'Pass'
      }}</label>

      <div v-if="mode === 'additional-criteria'">
        <label ref="text__level-1-title" for="input__level-1-title">Level Title (Highest)</label>
        <b-form-input
          id="input__level-1-title"
          ref="input__level-1-title"
          v-model.trim="$v.criterion.pass_title.$model"
          type="text"
          placeholder="Insert your title"
          :state="$v.criterion.pass_title.$anyError ? false : null"
          aria-describedby="text-required__level-1-title-invalid-feedback"
          class="mt-2 input__level-1-title"
          :disabled="disabled || hasUserEnrolled"
        />
        <b-form-invalid-feedback
          id="text-required__level-1-title-invalid-feedback"
          ref="text-required__level-1-title-invalid-feedback"
          class="mt-2"
        >
          Title is required.
        </b-form-invalid-feedback>
      </div>

      <div>
        <label
          v-if="mode === 'additional-criteria'"
          ref="text__level-1-description"
          for="input__level-1-description"
          class="my-4"
          >Description</label
        >
        <b-form-textarea
          :id="
            mode === 'additional-criteria' ? 'input__level-1-description' : 'input__pass-criteria'
          "
          :ref="
            mode === 'additional-criteria' ? 'input__level-1-description' : 'input__pass-criteria'
          "
          v-model="$v.criterion.pass_criterion.$model"
          :class="
            mode === 'additional-criteria' ? 'input__level-1-description' : 'input__pass-criteria'
          "
          rows="4"
          :placeholder="mode === 'additional-criteria' ? 'Insert your description' : ''"
          :state="$v.criterion.pass_criterion.$anyError ? false : null"
          :disabled="disabled || hasUserEnrolled"
        ></b-form-textarea>
        <b-form-invalid-feedback
          :ref="
            mode === 'additional-criteria'
              ? 'text-required__level-1-description'
              : 'text-required__pass-criteria'
          "
        >
          {{ mode === 'additional-criteria' ? 'Description is required.' : 'Pass is required.' }}
        </b-form-invalid-feedback>
      </div>
    </div>

    <!-- Additional criteria or Other level-->
    <div v-if="mode === 'additional-criteria'">
      <div
        v-for="(criterionItem, index) of criterion.additional_criteria"
        :key="`additional-criteria-${index}`"
        class="mt-4"
      >
        <div :class="{ 'card card__custom': index > 0 }">
          <div :class="`input__level-${index + 2}-title`">
            <div :class="{ card__title: index > 0 }">
              <label
                :ref="`text__level-${index + 2}-title`"
                :for="`input__level-${index + 2}-title`"
                >Level Title</label
              >
              <font-awesome-icon
                v-if="index > 0 && !hasUserEnrolled"
                :ref="`img__icon-close-level-${index + 2}`"
                icon="xmark"
                size="lg"
                class="icon__xmark"
                @click="onClickDelete(index, criterionItem)"
              />
            </div>
            <b-form-input
              :id="`input__level-${index + 2}-title`"
              :ref="`input__level-${index + 2}-title`"
              v-model.trim="$v.criterion.additional_criteria.$each[index].title.$model"
              type="text"
              placeholder="Insert your title"
              :aria-describedby="`text-required__level-${index + 2}-title-invalid-feedback`"
              :class="`mt-2 input__level-${index + 2}-title`"
              :state="$v.criterion.additional_criteria.$each[index].title.$anyError ? false : null"
              :disabled="disabled || hasUserEnrolled"
            />
            <b-form-invalid-feedback
              :id="`text-required__level-${index + 2}-title-invalid-feedback`"
              :ref="`text-required__level-${index + 2}-title-invalid-feedback`"
              class="mt-2"
            >
              Title is required.
            </b-form-invalid-feedback>
          </div>

          <div :class="`input__level-${index + 2}-description`">
            <label
              :ref="`text__level-${index + 2}-description`"
              :for="`input__level-${index + 2}-description`"
              class="my-4"
              >Description</label
            >

            <b-form-textarea
              :id="`input__level-${index + 2}-description`"
              :ref="`input__level-${index + 2}-description`"
              v-model.trim="$v.criterion.additional_criteria.$each[index].description.$model"
              :class="`input__level-${index + 2}-description`"
              rows="4"
              :state="
                $v.criterion.additional_criteria.$each[index].description.$anyError ? false : null
              "
              placeholder="Insert your description"
              :disabled="disabled || hasUserEnrolled"
            ></b-form-textarea>

            <b-form-invalid-feedback
              :id="`text-required__level-${index + 2}-description`"
              :ref="`text-required__level-${index + 2}-description`"
            >
              Description is required.
            </b-form-invalid-feedback>
          </div>
        </div>
      </div>

      <b-button
        v-if="criterion.additional_criteria.length < 3 && !hasUserEnrolled"
        variant="outline-primary"
        class="mt-4"
        @click="$emit('add:criteria')"
      >
        Add aditional criteria
      </b-button>
    </div>

    <!-- Not yet criteria or Last level -->
    <div class="mt-4">
      <label
        v-if="mode === 'criteria'"
        ref="text__not-yet-criteria"
        for="input__not-yet-criteria"
        >{{ criterion.not_yet_title ? criterion.not_yet_title : 'Not yet' }}</label
      >

      <div v-if="mode === 'additional-criteria'">
        <label
          :ref="`text__level-${criterion.additional_criteria.length + 2}-title`"
          :for="`input__level-${criterion.additional_criteria.length + 2}-title`"
          >Level Title</label
        >
        <b-form-input
          :id="`input__level-${criterion.additional_criteria.length + 2}-title`"
          :ref="`input__level-${criterion.additional_criteria.length + 2}-title`"
          v-model.trim="$v.criterion.not_yet_title.$model"
          type="text"
          placeholder="Insert your title"
          :state="$v.criterion.not_yet_title.$anyError ? false : null"
          :aria-describedby="`text-required__level-${
            criterion.additional_criteria.length + 2
          }-title-invalid-feedback`"
          :class="`input__level-${criterion.additional_criteria.length + 2}-title mt-2`"
          :disabled="disabled || hasUserEnrolled"
        />
        <b-form-invalid-feedback
          :id="`text-required__level-${
            criterion.additional_criteria.length + 2
          }-title-invalid-feedback`"
          :ref="`text-required__level-${
            criterion.additional_criteria.length + 2
          }-title-invalid-feedback`"
          class="mt-2"
        >
          Title is required.
        </b-form-invalid-feedback>
      </div>

      <div>
        <label
          v-if="mode === 'additional-criteria'"
          :ref="`text__level-${criterion.additional_criteria.length + 2}-description`"
          :for="`input__level-${criterion.additional_criteria.length + 2}-description`"
          class="my-4"
          >Description</label
        >

        <b-form-textarea
          :id="
            mode === 'additional-criteria'
              ? `input__level-${criterion.additional_criteria.length + 2}-description`
              : 'input__not-yet-criteria'
          "
          :ref="
            mode === 'additional-criteria'
              ? `input__level-${criterion.additional_criteria.length + 2}-description`
              : 'input__not-yet-criteria'
          "
          v-model="$v.criterion.not_yet_criterion.$model"
          :class="
            mode === 'additional-criteria'
              ? `input__level-${criterion.additional_criteria.length + 2}-description`
              : 'input__not-yet-criteria'
          "
          rows="4"
          :state="$v.criterion.not_yet_criterion.$anyError ? false : null"
          :placeholder="mode === 'additional-criteria' ? 'Insert your description' : ''"
          :disabled="disabled || hasUserEnrolled"
        ></b-form-textarea>

        <b-form-invalid-feedback
          :ref="
            mode === 'additional-criteria'
              ? `text-required__level-${criterion.additional_criteria.length + 2}-description`
              : 'text-required__not-yet-criteria'
          "
        >
          {{ mode === 'additional-criteria' ? 'Description is required.' : 'Not yet is required.' }}
        </b-form-invalid-feedback>
      </div>
    </div>

    <modal-delete-criterion
      :show.sync="showModalDeleteCriterion"
      :criteria="additionalCriterionDelete"
      title="Delete this level"
      sub-title="Are you sure that you want to delete this level?"
      description='Click at the "Delete" button to delete this post.'
      delete-action-text="Delete"
      @emitDeleteCriterion="$emit('delete:criteria', indexForDelete, additionalCriterionDelete)"
    />
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import Criteria from '@/models/Criteria';
import ModalDeleteCriterion from '@/views/Post/components/ModalDeleteCriterion';

export default {
  components: {
    ModalDeleteCriterion
  },

  mixins: [validationMixin],

  props: {
    criteria: {
      type: Criteria,
      default: () => ({})
    },

    disabled: {
      type: Boolean,
      default: false
    },

    mode: {
      type: String,
      default: 'criteria'
    },

    triggerValidation: {
      type: Boolean,
      default: false
    },

    headerTitle: {
      type: String,
      default: 'Assessment Rubric'
    },

    hasUserEnrolled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      additionalCriterionDelete: {},
      indexForDelete: null,
      showModalDeleteCriterion: false
    };
  },

  computed: {
    criterion: {
      get() {
        return this.criteria;
      },
      set(v) {
        this.$emit('update:criteria', v);
      }
    }
  },

  watch: {
    triggerValidation: {
      immediate: true,
      handler(triggerValidation) {
        if (triggerValidation) {
          this.$v.criterion.$touch();
        }
      }
    }
  },

  validations() {
    return {
      criterion: {
        pass_title: { required },
        not_yet_title: { required },
        pass_criterion: { required },
        not_yet_criterion: { required },
        additional_criteria: {
          $each: {
            title: { required },
            description: { required }
          }
        }
      }
    };
  },

  methods: {
    onClickDelete(index, criterion) {
      const { id = null } = criterion;
      if (id) {
        this.indexForDelete = index;
        this.additionalCriterionDelete = criterion;
        this.showModalDeleteCriterion = true;
        return;
      } else {
        this.$emit('delete:criteria', index, criterion);
      }
    }
  }
};
</script>

<style lang="scss">
.card {
  &__custom {
    padding: 1rem;
    border: 1px solid rgba(122, 123, 151, 0.3);
  }

  &__title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
}

.icon__xmark {
  cursor: pointer;
}
</style>
